module.exports = __webpack_public_path__ + "static/media/chatbubble-ellipses.7b9e1983.svg";